import { render } from "./basictab.vue?vue&type=template&id=3fb55220"
import script from "./basictab.vue?vue&type=script&lang=js"
export * from "./basictab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__